import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a93cdf40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alerts-priority"
};
const _hoisted_2 = {
  class: "alerts-priority-value"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alerts-priority-1"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alerts-priority-2"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alerts-priority-3"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($options.valueFormated), 1), _createElementVNode("div", {
    class: _normalizeClass(['alerts-priority-bar', $options.levelClass])
  }, [_hoisted_3, _hoisted_4, _hoisted_5, _createVNode(_component_app_icon, {
    icon: "priority-arrow",
    class: "priority-arrow",
    style: _normalizeStyle({
      left: $options.percent + '%'
    })
  }, null, 8, ["style"])], 2)]);
}